// extracted by mini-css-extract-plugin
export default {"root":"mimic___style_root__voJcC","wrapperItems":"mimic___style_wrapperItems__tbl+M"};